import { ConfigProvider, App as AntdApp } from "antd";
import ru from "antd/lib/locale/ru_RU";
import { lightTheme } from "./shared/config/themes";
import {
  CookiesProvider,
  LanguageProvider,
  QueryProvider,
  RouteProvider as Routes,
} from "./shared/providers";

import "@ant-design/v5-patch-for-react-19";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getAntdLocale } from "./shared/utils/get-antd-locale";

function App() {
  const { i18n } = useTranslation();
  const [antdLocale, setAntdLocale] = useState(ru);

  useEffect(() => {
    setAntdLocale(getAntdLocale(i18n.language as "uz" | "oz" | "ru"));
  }, [i18n.language]);

  return (
    <QueryProvider>
      <ConfigProvider theme={lightTheme} locale={antdLocale}>
        <AntdApp>
          <LanguageProvider>
            <CookiesProvider>
              <Routes />
            </CookiesProvider>
          </LanguageProvider>
        </AntdApp>
      </ConfigProvider>
    </QueryProvider>
  );
}

export default App;
